module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/EG-f77e009869c76c3e259f8f5b3a649bd2.png";